import { gql } from 'graphql-request';

export interface QueryOptions {
	first?: number;
	skip?: number;
	filter?: Record<string, { prefix: string; value: string }>;
	orderBy?: string;
}

export class QueryParamFactory {
	public options: QueryOptions;
	constructor(options: QueryOptions) {
		this.options = options;
	}

	private genParam(name: string, param?: { prefix: string; value: string }) {
		if (!param) return '';
		return gql`${name}: {${param.prefix}: ${param.value}}`;
	}

	public build() {
		let params = '';
		if (this.options.filter) {
			params += gql`filter: {`;
			for (const key in this.options.filter) {
				params += this.genParam(key, this.options.filter[key]);
			}
			params += gql`}`;
		}

		params = this.addAttr(params, 'first', this.options.first);
		params = this.addAttr(params, 'skip', this.options.skip);
		params = this.addAttr(params, 'orderBy', this.options.orderBy);

		if (params.length > 0) {
			params = `(${params})`;
		}
		return params;
	}

	private addAttr(params: string, key: string, value?: string | number) {
		if (!value) return params;
		if (params.length > 0) {
			params += gql`, `;
		}
		params += gql`${key}: ${value}`;
		return params;
	}

	public toString() {
		return this.build();
	}
}
